// A photo-less avatar gets one of WhatsApp's profile colours, picked the way WhatsApp Web picks it:
// the last digit of the person's WhatsApp id (their phone number) indexes this list. So a contact
// has the same colour here as in the WhatsApp of whoever talks to them. Each colour is a pair of
// theme tokens: a soft surface and a strong content colour for the initials (tokens.css).
export const PROFILE_TONES = [
  "pink",
  "sky-blue",
  "yellow",
  "purple",
  "teal",
  "orange",
  "cobalt",
  "brown",
  "red",
  "green",
] as const;

export type ProfileTone = (typeof PROFILE_TONES)[number] | "gray";

export function profileTone(
  address: string | null | undefined,
  fallbackId = "",
): ProfileTone {
  const digits = (address ?? "").replace(/\D/g, "");
  if (digits) return PROFILE_TONES[Number(digits.at(-1))]!;
  // No phone number (a colleague, a workspace): a stable hash of the id or name.
  let h = 0;
  for (const ch of fallbackId) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PROFILE_TONES[h % PROFILE_TONES.length]!;
}
